<template>
  <div style="height: 100%;">
    <SplitContainer2 style="height: 100%" layout="horizontal" :split_setting="0.55">
      <template #table1>
        <TableMain name="one table" ref="UserTable" :fields="fields2" :title="table_title.title2"
          :show_query_container="false" :show_toolbar_container="true" :show_pagination_container="true"
          :show_date_picker="false" :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label"
          :query_button_label="query_lable" :loading_width="40" :isBusy="isBusy_table2"
          :show_toolbar_button="[0, 0, 0, 0, 0]" :show_bind_all="true" @current_changed="current_changed"
          @state_change="bind_all" :selectable="true" tableref="380fcc91de5d4f2881770b85fc7715ce">
          <template #toolbar>
            <el-badge :value="copyCustomersNum" :hidden="copyCustomersNum == 0" style="vertical-align: top !important">
              <el-tooltip content="拷贝所选用户拥有的客户" placement="top" effect="light">
                <el-button type="info" plain style="width: 55px" class="ml-2 iconfont icon-copy" @click="copyCustomers"
                  size="mini">
                </el-button>
              </el-tooltip>
            </el-badge>
            <el-tooltip content="客户粘贴" placement="top" effect="light">
              <el-button type="info" plain style="width: 55px" class="ml-5 iconfont icon-paste" @click="syncCustomers"
                size="mini"></el-button>
            </el-tooltip>
            <el-tooltip content="客户追加" placement="top" effect="light">
              <el-button type="info" plain style="width: 55px" class="ml-2 iconfont icon-append" @click="pasteCustomers"
                size="mini">
              </el-button>
            </el-tooltip>
          </template>
        </TableMain>
      </template>
      <template #table2>
        <TableMain name="one table" ref="CustTable1" :fields="fields" :title="table_title.title1"
          :show_query_container="false" :show_toolbar_container="true" :show_pagination_container="true"
          :show_date_picker="false" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
          :query_button_label="query_lable" :isBusy="isBusy_table1" :hb_table_class="'hb_table_custsei_class1'"
          :table_height_adjust="-8" :loading_width="60" :show_toolbar_button="[0, 0, 0, 0, 0]"
          tableref="2efbd73af07c4534b0058e196e0518d8">
          <!-- <template #query>
              {{$t("common.customer")+$t("common.num")}}：<el-input clearable size="small" style="width: 100px" v-model="AccountNum"></el-input>
               {{$t("common.customer")+$t("common.name")}}：<el-input clearable size="small" style="width: 120px" v-model="SEI_Name"></el-input>
            </template> -->
          <template #operation>
            <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="saveData"
              :label="$t('common.save')" class="ml-2">
              &nbsp;</QueryButton>
          </template>
        </TableMain>
      </template>
    </SplitContainer2>
  </div>
</template>

<script>
import * as CustTableBindUserController from "../../controllers/base/CustTableBindUserController"
import BaseContainer from "../components/BaseContainer"
import QueryButton from "../components/base/QueryButton"
import TestQueryPanel from "../components/base/TestQueryPanel"
import SplitContainer2 from "../components/container/SplitContainer2"
import BaseModal from "../components/modals/baseModal"
import TableMain from "../components/table/TableMain"

export default {
  name: "CustTableSEI",
  components: {
    BaseContainer,
    TableMain,
    BaseModal,
    TestQueryPanel,
    SplitContainer2,
    QueryButton,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_sei_customer",
        title2: "table_user_employees",
      },
      fields: CustTableBindUserController.fields.default,
      fields2: CustTableBindUserController.fields.user_fields,
      isBusy_table1: false,
      isBusy_table2: false,
      AccountNum: "",
      SEI_Name: "",
      selectedItem: null,
      copyCustomersNum: 0,
      copyItems: [],
    }
  },
  created() {
    this.getUserData()
  },
  mounted() {
    this.excuteQuery()
  },
  methods: {
    //绑定所有客户
    async bind_all(data, cb) {

      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      if (data.state == "bind_all") {
        if (data.selected_items.length > 0) {
          let _userIds = []
          _.each(data.selected_items, (t) => {
            _userIds.push({
              id: t.id,
              username: t.username,
              realname: t.realname,
              email: t.email,
              department: t.department,
              description: t.description,
              is_valid: t.is_valid,
              isDomainUser: t.isDomainUser,
              isInternal: t.isInternal,
            })
          })
          let _result = await CustTableBindUserController.methods.bind_all(
            _userIds,
            true
          )
          if (!_.isNull(_result)) {
            if (_result && _result.Success) {
              _.each(_userIds, (t) => {
                let _m = _.find(this.$refs.UserTable.my_data, {
                  id: t.id,
                })
                if (_m) {
                  _m.is_Include_All = true
                }
              })

              this.msgToasts(this.$t("notify.action_successfully"), "success")
              cb(true, true)
            } else {
              this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
              cb(false)
            }
          } else {
            cb(false)
          }
        }
      } else {
        if (data.selected_items.length > 0) {
          let _userIds = []
          _.each(data.selected_items, (t) => {
            _userIds.push({
              id: t.id,
              username: t.username,
              realname: t.realname,
              email: t.email,
              department: t.department,
              description: t.description,
              is_valid: t.is_valid,
              isDomainUser: t.isDomainUser,
              isInternal: t.isInternal,
            })
          })
          let _result = await CustTableBindUserController.methods.bind_all(
            _userIds,
            false
          )
          if (!_.isNull(_result)) {
            if (_result && _result.Success) {
              _.each(_userIds, (t) => {
                let _m = _.find(this.$refs.UserTable.my_data, {
                  id: t.id,
                })
                if (_m) {
                  _m.is_Include_All = false
                }
              })

              this.msgToasts(this.$t("notify.action_successfully"), "success")
              cb(true, true)
            } else {
              this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
              cb(false)
            }
          } else {
            cb(false)
          }
        }
      }
    },
    //拷贝客户
    async copyCustomers() {
      this.copyItems = []
      if (!this.$refs.UserTable.GetCurrentItem()) {
        this.msgToasts("请选择要复制的用户!", "info")
        return
      }
      if (this.$refs.CustTable1.GetSelectedItems().length < 1) {
        this.copyCustomersNum = 0
        return
      }
      _.each(this.$refs.CustTable1.GetSelectedItems(), (t) => {
        this.copyItems.push({ AccountNum: t.AccountNum })
      })
      this.copyCustomersNum = this.copyItems.length
      this.msgToasts("已拷贝用户客户!", "success")
    },
    //同步客户
    async syncCustomers() {
      if (this.$refs.UserTable.GetSelectedItems().length == 0) {
        this.msgToasts("请选择要粘贴的用户!", "info")
        return
      }
      if (this.copyItems.length == 0) {
        this.msgToasts("没有需要粘贴的项!", "info")
        return
      }
      this.msgModal("同步客户将清除用户已绑定的所有客户,确定此操作?").then(
        async (value) => {
          if (value) {
            let users = []
            _.each(this.$refs.UserTable.GetSelectedItems(), (t) => {
              users.push(t.id)
            })
            let _result =
              await CustTableBindUserController.methods.syncUserCustomers(
                users,
                this.copyItems
              )
            if (_result && _result.length > 0) {
              this.msgToasts(this.$t("notify.action_successfully"), "success")
            }
          }
        }
      )
    },
    //追加客户
    async pasteCustomers() {
      if (this.$refs.UserTable.GetSelectedItems().length == 0) {
        this.msgToasts("请选择要粘贴的用户!", "info")
        return
      }
      if (this.copyItems.length == 0) {
        this.msgToasts("没有需要粘贴的项!", "info")
        return
      }
      let users = []
      _.each(this.$refs.UserTable.GetSelectedItems(), (t) => {
        users.push(t.id)
      })
      let _result =
        await CustTableBindUserController.methods.pasteUserCustomers(
          users,
          this.copyItems
        )
      if (_result && _result.length > 0) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
      }
    },
    //保存客户与用户的关系
    async saveData(cb) {
      if (!this.selectedItem) {
        this.msgToasts(this.$t("notify.not_selected_user"), "info")
        cb(false)
        return
      }
      // if (this.$refs.CustTable1.GetSelectedItems().length < 1) {
      //   this.msgToasts("没有要保存的项目!", "info");
      //   cb(false);
      //   return;
      // }

      let result = await CustTableBindUserController.methods.saveData(
        this.selectedItem,
        this.$refs.CustTable1.all_selected_items
      )

      //
      if (result.length > 0) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true)
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "info")
        cb(false)
      }
    },
    async getUserData() {
      let _result = await CustTableBindUserController.methods.getUserData()

      if (_result && _result.length > 0) {
        _result = _.filter(_result, (t) => {
          return !t.is_deleted
        })
        this.$refs.UserTable.SetData(_.orderBy(_result, ["id"], ["asc"]))
      }
    },
    //#region 查询
    // async on_query(set_data, date_range) {
    //   this.selectedItem = null;
    //   this.$refs.CustTable1.setSelect([]);
    //   this.isBusy_table1 = true;
    //   // if (_.isNull(date_range)) {
    //   //   this.msgModal(this.$t("notify.wait_too_long")).then(
    //   //     async value => {
    //   //       if (value) {
    //   //         await this.excuteQuery(set_data, date_range);
    //   //       }
    //   //     }
    //   //   );
    //   // } else {

    //   //}
    //   await this.excuteQuery(set_data);
    // },
    async excuteQuery() {
      let _this = this
      // let _fromDate = "",
      //   _toDate = "";
      let _params = {
        AccountNum: { like: "%" + this.AccountNum + "%" },
        SEI_Name: { like: "%" + this.SEI_Name + "%" },
      }

      _this.$refs.CustTable1.SetData([])
      let _result = await CustTableBindUserController.methods.getData(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        _this.$refs.CustTable1.SetData(
          _.orderBy(_result[0], ["modifiedDateTime"], ["desc"])
        )
      }
      this.isBusy_table1 = false
    },
    //#endregion

    async current_changed(old, current) {
      //this.isBusy_table1 = true;
      this.selectedItem = current
      let result = await this.getRelationData(current)
      if (this.$refs.CustTable1.only_selected) {
        this.$refs.CustTable1.on_only_selected()
      }

      let dataList = []
      if (result) {
        for (var i in result[0]) {
          let _data = _.find(this.$refs.CustTable1.my_data, {
            AccountNum: result[0][i].AccountNum,
          })
          if (_data) {
            dataList.push({
              id: _data.id,
            })
          }
        }
        if (dataList) {
          this.$refs.CustTable1.setSelect(dataList)
        }
      }
      //this.isBusy_table1 = false;
    },
    async getRelationData(current) {
      if (!current) {
        return
      }
      let _params = {
        user_id: { "=": current.id },
      }
      return await CustTableBindUserController.methods.getRelation(_params)
    },
  },
}
</script>
<style>
.hb_table_custsei_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 180rem;
}
</style>
